<template>
  <v-container
    id="comercial-form"
    fluid
    tag="section"
    class="px-3 pt-0"
    style="margin-top: 1rem"
  >
    <v-row>
      <v-col
        cols="12"
        lg="12"
        class="px-1"
      >
        <v-container>
          <dashboard-filtro-mais-vida
            :primeiro="enablePrimeiroDia"
            :ultimo="enableUltimoDia"
            :empresas="enableEmpresa"
            :url="link"
            :clientes="enableClientes"
            :cidades="enableCidades"
            :areas="enableAreas"
            :vendedores="enableVendedores"
            :redes="enableRedes"
            :produtos="enableProdutos"
            :linhas="enableLinhas"
            :btn1="enableBtn"
            :btn2="disableBtn"
            :caixas="enableCaixas"
            :enable-datas="enableDatas"
            :enable-datas1="enableDatas"
            :filtro-completo="enableFiltro"
            :segmentos="enableSegmento"
            :filtro-datas-iguais="filtroDatasIguais"
          />
        </v-container>
        <v-container>
          <v-row
            v-if="enableBtnPrint"
            id="btnPrint"
          >
            <v-btn
              class="col-4 col-sm-3 col-md-1 col-lg-1"
              small
              :color="corPrimaria"
              dark
              :loading="imprimindo"
              @click="imprimir()"
            >
              <v-icon>
                mdi-printer
              </v-icon>
              Imprimir
              <template v-slot:loader>
                <span>Imprimindo...</span>
              </template>
            </v-btn>
          </v-row>
        </v-container>
        <v-row
          id="clienteTempo"
        >
          <v-col
            cols="12"
            sm="12"
            md="12"
            lg="12"
          >
            <v-card
              id="cardDashbord"
              class="mx-auto"
              outlined
            >
              <div class="card-header-dashbord">
                <v-row>
                  <v-col
                    cols="12"
                    sm="10"
                    md="10"
                    lg="10"
                    class="d-flex flex-wrap"
                  >
                    Fluxo de Venda
                  </v-col>
                  <v-col
                    cols="12"
                    sm="2"
                    md="2"
                    lg="2"
                    class="d-flex justify-end"
                  >
                    <v-tooltip
                      top
                      max-width="400"
                      width="400"
                    >
                      <template
                        v-slot:activator="{ on, attrs }"
                      >
                        <v-icon
                          id="iconInformationClientesParcipantes"
                          class="text-left"
                          v-bind="attrs"
                          v-on="on"
                          @mouseover="enableTexto('231')"
                        >
                          mdi-information-outline
                        </v-icon>
                      </template>
                      <div
                        v-if="!carregandoTooltip"
                        v-html="textoOrientacao"
                      />
                    </v-tooltip>
                  </v-col>
                </v-row>
              </div>
              <v-card-actions>
                <v-row>
                  <v-col
                    cols="12"
                    sm="12"
                    md="12"
                    lg="12"
                  >
                    <dashboard-faturamento-cliente-tempo id="componenteFluxoVenda" />
                  </v-col>
                </v-row>
              </v-card-actions>
            </v-card>
          </v-col>
        </v-row>
      </v-col>
    </v-row>
    <dashboard-core-snackbar
      v-model="snackbar.visible"
      :visible="snackbar.visible"
      :timeout="snackbar.timeout"
      :color="snackbar.color"
      :message="snackbar.message"
    />
  </v-container>
</template>

<script>
  import utils from '../../../../services/utils'
  import Permissao from '../../../../services/menu'
  import eventEmit from '../../components/core/EventoEmit'
  import JSPDF from 'jspdf'
  import 'jspdf-autotable'

  export default {
    name: 'PageMaisVida05',
    emits: ['updateFormMaisVida', 'atualizarTexto'],
    components: {
      DashboardCoreSnackbar: () => import('../../components/core/Snackbar'),
      DashboardFiltroMaisVida: () => import('../../components/core/FiltrosMaisVida'),
      DashboardFaturamentoClienteTempo: () => import('../../components/comercial/FaturamentoClienteTempo'),
    },
    mixins: [utils],
    data: () => ({
      appOnline: navigator.onLine,
      corPrimaria: localStorage.corPrimaria,
      usuarioIdentificado: false,
      snackbar: {
        visible: false,
        color: 'success',
        direction: 'top center',
        message: 'My timeout is set to 3000.',
        timeout: 3000,
      },
      link: window.location.href,
      dataInicial: (new Date(new Date().getFullYear(), new Date().getMonth(), 1)).toISOString().substr(0, 10),
      dataFinal: (new Date(new Date().getFullYear(), new Date().getMonth() + 1, 0)).toISOString().substr(0, 10),
      empresa: [],
      clientes: [],
      cidades: [],
      areas: [],
      vendedores: [],
      redes: [],
      produtos: [],
      dataInicial1: (new Date(new Date().getFullYear(), new Date().getMonth(), 1)).toISOString().substr(0, 10),
      dataFinal1: (new Date(new Date().getFullYear(), new Date().getMonth() + 1, 0)).toISOString().substr(0, 10),
      empresa1: [],
      clientes1: [],
      cidades1: [],
      areas1: [],
      vendedores1: [],
      redes1: [],
      produtos1: [],
      segmento: [],
      paginaEnable: true,
      enablePrimeiroDia: true,
      enableUltimoDia: true,
      disablePrimeiroDia: false,
      disableUltimoDia: false,
      enableEmpresa: true,
      enableClientes: false,
      enableCidades: true,
      enableAreas: true,
      enableVendedores: true,
      enableRedes: true,
      enableProdutos: true,
      enableLinhas: false,
      enableBtn: true,
      disableBtn: false,
      enableCaixas: false,
      enableDatas: true,
      disableDatas: false,
      enableFiltro: true,
      enableSegmento: true,
      filtroDatasIguais: false,
      codigo: 0,
      orientacao: [],
      codigoIds: ['231'],
      textoFluxoVenda: '',
      dynamicPaddingFluxoVenda: '',
      imprimindo: false,
      enableBtnPrint: false,
      headersFaturamento: [
        { text: 'Cliente', value: 'cliente', align: 'left', class: 'black--text title' },
        { text: 'Última venda', value: 'data', align: 'center', class: 'black--text title' },
        { text: 'Volume', value: 'volume', align: 'right', class: 'black--text title' },
      ],
      headersFaturamentoCliente: [
        { text: 'Cliente', value: 'cliente', align: 'left', class: 'black--text title' },
        { text: 'Volume', value: 'volume', align: 'right', class: 'black--text title' },
      ],
      headersFaturamentoClienteProduto: [
        { text: 'Produto', value: 'produto', align: 'left', class: 'black--text title' },
        { text: 'Última venda', value: 'data', align: 'center', class: 'black--text title' },
        { text: 'Volume', value: 'volume', align: 'right', class: 'black--text title' },
      ],
      dadosFaturamentoCliente: [],
      dadosFatClienteProduto: [],
      textoOrientacao: '',
      carregandoTooltip: false,
      codigoAtual: null,
    }),

    created () {
      eventEmit.$on('update-dados-mais-vida', this.handleUpdateDados)

      eventEmit.$on('set-dados-faturamento-cliente-tempo', this.handleDadosFaturamento)

      eventEmit.$on('set-dados-faturamento-cliente-produto', this.handleDadosFaturamentoProduto)
    },

    beforeDestroy () {
      eventEmit.$off('update-dados-mais-vida', this.handleUpdateDados)

      eventEmit.$off('set-dados-faturamento-cliente-tempo', this.handleDadosFaturamento)

      eventEmit.$off('set-dados-faturamento-cliente-produto', this.handleDadosFaturamentoProduto)

      window.removeEventListener('resize', this.updateDynamicPadding)
    },

    mounted () {
      if (localStorage.tokencontrato) {
        eventEmit.$emit('atualizar_texto', 'Fluxo Venda')

        this.updateDynamicPadding()

        window.addEventListener('resize', this.updateDynamicPadding)

        this.usuarioIdentificado = true
      } else {
        this.usuarioIdentificado = false
        this.$router.push('/login')
      }
    },

    methods: {
      updateDynamicPadding () {
        if (window.innerWidth > 1800) {
          this.dynamicPaddingFluxoVenda = 'padding-right: 115rem !important'
        } else if (window.innerWidth > 1380 && window.innerWidth <= 1800) {
          this.dynamicPaddingFluxoVenda = 'padding-right: 93rem !important'
        } else if (window.innerWidth > 380 && window.innerWidth < 600) {
          this.dynamicPaddingFluxoVenda = 'padding-right: 18rem !important'
        } else if (window.innerWidth > 601 && window.innerWidth < 1000) {
          this.dynamicPaddingFluxoVenda = 'padding-right: 30rem !important'
        } else {
          this.dynamicPaddingFluxoVenda = 'padding-right: 75rem !important'
        }
      },

      handleUpdateDados (dataInicial, dataFinal, empresaSelect, cidadeSelect, areaSelect, redeSelect, vendedorSelect, produtoSelect, linhaSelect, clienteSelect, caixaSelect, tipoDevolucao, motivoDevolucao, dataInicial1, dataFinal1, empresaSelect1, cidadeSelect1, areaSelect1, redeSelect1, vendedorSelect1, produtoSelect1, linhaSelect1, clienteSelect1, caixaSelect1, receita, segmento, segmento1) {
        this.dataInicial = dataInicial
        this.dataFinal = dataFinal
        this.empresa = empresaSelect
        this.cidades = cidadeSelect
        this.areas = areaSelect
        this.redes = redeSelect
        this.vendedores = vendedorSelect
        this.produtos = produtoSelect
        this.clientes = clienteSelect
        this.dataInicial1 = dataInicial1
        this.dataFinal1 = dataFinal1
        this.empresa1 = empresaSelect
        this.cidades1 = cidadeSelect
        this.areas1 = areaSelect
        this.redes1 = redeSelect
        this.vendedores1 = vendedorSelect
        this.produtos1 = produtoSelect
        this.clientes1 = clienteSelect
        this.segmento = segmento

        this.updateDados()
      },

      handleDadosFaturamento (dadosCliente) {
        this.dadosFatClienteProduto = dadosCliente

        this.enableBtnPrint = true
      },

      handleDadosFaturamentoProduto (dadosProduto) {
        this.dadosFaturamentoCliente = dadosProduto
      },

      formatDate (date) {
        if (!date) return null

        const [year, month, day] = date.split('-')
        return `${day}/${month}/${year}`
      },

      parseDate (date) {
        if (!date) return null

        const [month, day, year] = date.split('/')
        return `${year}-${month.padStart(2, '0')}-${day.padStart(2, '0')}`
      },

      async enableTexto (value) {
        if (this.codigoAtual === value && this.textoOrientacao) return

        this.codigoAtual = value
        this.carregandoTooltip = true
        this.textoOrientacao = ''

        try {
          const resposta = await Permissao.showOrientacaoIndicador(localStorage.username, localStorage.tokencontrato, value)

          if (resposta.data.status) {
            this.textoOrientacao = resposta.data.orientacao
            this.codigo = value
          }
        } catch (e) {
          if (e.message === 'Network Error') {
            this.showSnackbar('error', 3000, 'Falha na conexão com a internet')
          }
        } finally {
          this.carregandoTooltip = false
        }
      },

      updateDados () {
        const data1 = this.dataInicial.substring(0, 7)
        const data2 = this.dataInicial1.substring(0, 7)
        const data3 = this.dataFinal.substring(0, 7)
        const data4 = this.dataFinal1.substring(0, 7)

        var dataInicio1 = new Date(this.dataInicial)
        var dataIncio2 = new Date(this.dataInicial1)

        var diferencaEmMilissegundos = Math.abs(dataIncio2 - dataInicio1)

        var diferencaEmMeses = diferencaEmMilissegundos / (1000 * 60 * 60 * 24 * 30.44)

        if (diferencaEmMeses > 3 && this.areas.length === 0 && this.vendedores.length === 0 && this.redes.length === 0) {
          alert('Para exibição dos dados quando os filtros são uma diferença de 4 mesês favor selecionar algum vendedor, área ou redes.')
        } else if (this.dataInicial === this.dataInicial1 || this.dataFinal === this.dataFinal1 || data1 === data2 || data3 === data4) {
          alert('Datas do filtro 1 e filtro 2 não podem ter períodos iguais, favor atualizar para exibição dos dados, para exibir os dados.')
        } else {
          eventEmit.$emit('update-form-mais-vida', this.dataInicial, this.dataFinal, this.empresa, this.cidades, this.areas, this.vendedores, this.redes, this.produtos, this.clientes, this.dataInicial1, this.dataFinal1, this.empresa1, this.cidades1, this.areas1, this.vendedores1, this.redes1, this.produtos1, this.clientes1, this.segmento)
        }
      },

      async imprimir () {
        try {
          this.imprimindo = true

          await setTimeout(() => {
            this.print()
          }, 2000)
        } catch (error) {
          console.error('Erro ao imprimir:', error)
        }
      },

      async print () {
        try {
          const pdf = new JSPDF('landscape', 'mm')
          let posYFiltros = 10

          const filtro = 'Filtros selecionados tabela 1'
          pdf.text(filtro, 105, posYFiltros)

          const dataInicial = this.dataInicial.substr(8) + '/' + this.dataInicial.substr(5, 2) + '/' + this.dataInicial.substr(0, 4)
          const ultimoDia = this.dataFinal.substr(8) + '/' + this.dataFinal.substr(5, 2) + '/' + this.dataFinal.substr(0, 4)

          const datas = 'Data inicial: ' + dataInicial + ' - Data final: ' + ultimoDia
          posYFiltros += 10
          pdf.setFontSize(10)
          pdf.text(datas, 15, posYFiltros)

          posYFiltros += 10

          const adicionarFiltros = async (pdf, posYFiltros, titulo, dados) => {
            if (dados.length > 0) {
              let texto = titulo + ' '

              for (let i = 0; i < dados.length; i++) {
                texto += dados[i] + ', '
              }

              texto = texto.slice(0, -2)

              const linhas = this.quebrarString(texto, 135)

              linhas.forEach((linha, index) => {
                if (posYFiltros === 200) {
                  pdf.addPage()

                  posYFiltros = 10

                  pdf.text(linha, 15, posYFiltros)

                  posYFiltros += 10
                } else {
                  pdf.text(linha, 15, posYFiltros)

                  posYFiltros += 10
                }
              })
            }

            return posYFiltros
          }

          posYFiltros = await adicionarFiltros(pdf, posYFiltros, 'Empresa(s) Selecionada(s):', this.empresa.map(e => e.nomeExibicao))
          posYFiltros = await adicionarFiltros(pdf, posYFiltros, 'Cidade(s) Selecionada(s):', this.cidades.map(e => e.cidade))
          posYFiltros = await adicionarFiltros(pdf, posYFiltros, 'Área(s) Selecionada(s):', this.areas.map(a => a.area))
          posYFiltros = await adicionarFiltros(pdf, posYFiltros, 'Vendedor(es) Selecionado(s):', this.vendedores.map(v => v.vendedor))
          posYFiltros = await adicionarFiltros(pdf, posYFiltros, 'Rede(s) Selecionada(s):', this.redes.map(r => r.rede))
          posYFiltros = await adicionarFiltros(pdf, posYFiltros, 'Produto(s) Selecionado(s):', this.produtos.map(p => p.produto))
          posYFiltros = await adicionarFiltros(pdf, posYFiltros, 'Segmento(s) Selecionado(s):', this.segmento.map(se => se.segmento))

          if (posYFiltros > 150) {
            pdf.addPage()
            posYFiltros = 10
          }

          if (this.dadosFaturamentoCliente.length > 0) {
            const title = 'Tabela 1'
            pdf.text(title, 15, posYFiltros)

            posYFiltros += 5

            const dadosFaturamentoCliente = this.dadosFaturamentoCliente.map(item => [item.cliente, item.dataExibicao, item.volumeExibicao])

            pdf.autoTable({
              head: [this.headersFaturamento.map(header => ({ content: header.text, styles: { fontSize: 10, textColor: [0, 0, 0] } }))],
              body: dadosFaturamentoCliente.map(row => row.map((cell, index) => {
                const isFaturamentoColumn = index === 2
                return {
                  content: cell,
                  styles: {
                    fontSize: 8,
                    textColor: [0, 0, 0],
                    halign: isFaturamentoColumn ? 'right' : 'left',
                  },
                }
              })),
              startY: posYFiltros,
              styles: { fontSize: 10 },
            })

            pdf.addPage()
            posYFiltros = 10
          }

          const filtro1 = 'Filtros selecionados tabela 2'
          pdf.setFontSize(16)
          pdf.text(filtro1, 105, posYFiltros)

          const dataInicial1 = this.dataInicial1.substr(8) + '/' + this.dataInicial1.substr(5, 2) + '/' + this.dataInicial1.substr(0, 4)
          const ultimoDia1 = this.dataFinal1.substr(8) + '/' + this.dataFinal1.substr(5, 2) + '/' + this.dataFinal1.substr(0, 4)

          const datas1 = 'Data inicial: ' + dataInicial1 + ' - Data final: ' + ultimoDia1
          posYFiltros += 10
          pdf.setFontSize(10)
          pdf.text(datas1, 15, posYFiltros)

          posYFiltros += 10

          const title2 = 'Tabela 2'
          pdf.text(title2, 15, posYFiltros)

          posYFiltros += 5

          let previousTableY = posYFiltros

          this.dadosFatClienteProduto.forEach((row, index) => {
            const dadosTabelaPrincipal = [
              [row.cliente, row.volumeExibicao],
            ]

            const tablePrincipal = pdf.autoTable({
              head: [this.headersFaturamentoCliente.map(header => ({ content: header.text, styles: { fontSize: 10, textColor: [0, 0, 0] } }))],
              body: dadosTabelaPrincipal.map(row => row.map((cell, index) => {
                const isFaturamentoColumn = index === 1
                return {
                  content: cell,
                  styles: {
                    fontSize: 8,
                    textColor: [0, 0, 0],
                    halign: isFaturamentoColumn ? 'right' : 'left',
                  },
                }
              })),
              startY: previousTableY,
              styles: { fontSize: 10 },
              columnStyles: {
                0: { cellWidth: 220 },
                2: { cellWidth: 50 },
              },
            })

            previousTableY = tablePrincipal.lastAutoTable.finalY

            const dadosDetalhesProdutos = row.produtos.map(item => [item.produto, item.dataExibicao, item.volumeExibicao])

            const tableDetalhes = pdf.autoTable({
              head: [this.headersFaturamentoClienteProduto.map(header => ({ content: header.text, styles: { fontSize: 10, textColor: [0, 0, 0] } }))],
              body: dadosDetalhesProdutos.map(row => row.map((cell, index) => {
                const isFaturamentoColumn = index === 2
                return {
                  content: cell,
                  styles: {
                    fontSize: 8,
                    textColor: [0, 0, 0],
                    halign: isFaturamentoColumn ? 'right' : 'left',
                  },
                }
              })),
              startY: previousTableY,
              styles: { fontSize: 10 },
              columnStyles: {
                0: { cellWidth: 170 },
                1: { cellWidth: 50 },
                2: { cellWidth: 49 },
              },
            })

            previousTableY = tableDetalhes.lastAutoTable.finalY
          })

          pdf.save('relatorio_fluxo_venda.pdf')
        } catch (error) {
          console.error('Erro ao gerar PDF:', error)
        } finally {
          this.dadosFaturamento = []

          this.imprimindo = false
        }
      },

      quebrarString (str, limiteCaracteresPorLinha) {
        const palavras = str.split(' ')
        let linhaAtual = ''
        const linhas = []

        palavras.forEach(palavra => {
          if ((linhaAtual + palavra).length <= limiteCaracteresPorLinha) {
            linhaAtual += palavra + ' '
          } else {
            linhas.push(linhaAtual.trim())
            linhaAtual = palavra + ' '
          }
        })

        if (linhaAtual !== '') {
          linhas.push(linhaAtual.trim())
        }

        return linhas
      },

      showSnackbar (color, timeout, message) {
        this.snackbar.message = message
        this.snackbar.color = color
        this.snackbar.visible = true
        this.snackbar.timeout = timeout
      },
    },
  }
</script>

<style scoped>
  #cardDashbord {
    border-radius: 14px;
    border: 1px solid rgba(0,0,0,0.05);
    box-shadow:
      0 2px 4px rgba(0,0,0,0.08),
      0 6px 12px rgba(0,0,0,0.06),
      0 12px 24px rgba(0,0,0,0.04);
    transition: all 0.25s ease;
    transform: translateY(-3px);
    box-shadow:
      0 4px 8px rgba(0,0,0,0.10),
      0 12px 22px rgba(0,0,0,0.09),
      0 20px 32px rgba(0,0,0,0.06);
  }

  .card-header-dashbord {
    background-color: #ffffff;
    padding: 14px 18px;
    font-weight: 600;
    font-size: 14px;
    color: black;
    border-bottom: 1px solid #b7b1b1;
    border-radius: 14px 14px 0 0;
  }

  #componenteFluxoVenda {
    margin: -3rem 0 0 0
  }

  @media screen
  and (min-device-width : 320px)
  and (max-device-width : 560px) {

  }

  @media screen
  and (min-width : 481px)
  and (max-width : 960px)
  and (-webkit-min-device-pixel-ratio: 1) {

  }

  @media screen
  and (min-width: 1380px) {

  }
</style>

<style lang="sass">

  #clienteTempo
    max-width: 1800px !important

  .highlighted-item
    background-color: #2863af
    padding: 16px
    color: white
    margin: -1rem 0 0 0

  #listItemFluxoVenda
    margin: -2rem 0 0 -1rem

</style>
